import $ from "cash-dom";
import { initModules } from './modules/index';

import '../css/_index.css';

/**
 * DOMReady
 */
$(() => {
    initModules( $('html') );
});